import activityConfig from "emun.activity/activity.config";
import dateRangeUrl from "emun.salesrep/date-range.htm";
import dashboardQuickReportFilters from "emun.salesrep/quick-report-filters.htm";
import templateUrl from "emun.salesrep/salesrep-dashboard.htm";
import salesrepConfig from "emun.salesrep/salesrep.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

class SalesRepDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    var map = this;
    let $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.activityConfig = activityConfig;
    $ctrl.chartLoaded = false;
    $ctrl.productImage = $appConfig.productImage;
    let options = {
      url: "QuerySalesReps.json?IncludeSalesData=true&Id=" + $ctrl.repId,
      pageSize: 15,
      orderBy: "Name",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.rep = args.first;
        $ctrl.$state.current.customTitle = $ctrl.rep.name;
      },
    };
    $ctrl.goals = {
      month: 0,
      monthPercent: 0,
      quarter: 0,
      quarterPercent: 0,
      year: 0,
      yearPercent: 0,
    };
    $ctrl.dailySales = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdaySales = {
      total: 0,
      count: 0,
    };
    $ctrl.weekSales = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekSales = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterSales = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdSales = {
      total: 0,
      count: 0,
    };
    $ctrl.mtdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdSales = {
      total: 0,
      count: 0,
    };
    $ctrl.ttmSales = {
      total: 0,
      count: 0,
    };

    $ctrl.dailyInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdayInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.weekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.mtdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdInvoice = {
      total: 0,
      count: 0,
    };

    $ctrl.query = createAutoQuery(options);
    $ctrl.dailySalesQuery = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesQuarterToDate,TotalSalesCountQuarterToDate,TotalSalesQuarterToDateLastYear,TotalSalesCountQuarterToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear,TotalSalesTTM,TotalSalesCountTTM&GroupBy=SalesRepID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          var res = args.first;
          $ctrl.dailySales.total = res.sumTotalSalesToday;
          $ctrl.dailySales.count = res.sumTotalSalesCountToday;
          $ctrl.yesterdaySales.total = res.sumTotalSalesYesterday;
          $ctrl.yesterdaySales.count = res.sumTotalSalesCountYesterday;
          $ctrl.weekSales.total = res.sumTotalSalesWeekToDate;
          $ctrl.weekSales.count = res.sumTotalSalesCountWeekToDate;
          $ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
          $ctrl.quarterSales.count += res.sumTotalSalesCountQuarterToDate;
          $ctrl.lastquarterSales.total +=
            res.sumTotalSalesQuarterToDateLastYear;
          $ctrl.lastquarterSales.count +=
            res.sumTotalSalesCountQuarterToDateLastYear;
          $ctrl.ttmSales.total += res.sumTotalSalesTTM;
          $ctrl.ttmSales.count += res.sumTotalSalesCountTTM;
          var percent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100
          );
          if ($ctrl.lastquarterSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.quarterSales.percent = 100 - percent;
            $ctrl.quarterSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.quarterSales.percent = percent - 100;
            $ctrl.quarterSales.trend = "up";
          } else {
            $ctrl.quarterSales.percent = 100;
            $ctrl.quarterSales.trend = "neutral";
          }
          $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
          $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
          $ctrl.lastytdSales.total += res.sumTotalSalesYearToDateLastYear;
          $ctrl.lastytdSales.count += res.sumTotalSalesCountYearToDateLastYear;
          percent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
          );
          if ($ctrl.lastytdSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.ytdSales.percent = 100 - percent;
            $ctrl.ytdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.ytdSales.percent = percent - 100;
            $ctrl.ytdSales.trend = "up";
          } else {
            $ctrl.ytdSales.percent = 100;
            $ctrl.ytdSales.trend = "neutral";
          }
          $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
          $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
          $ctrl.lastmtdSales.total += res.sumTotalSalesMonthToDateLastYear;
          $ctrl.lastmtdSales.count += res.sumTotalSalesCountMonthToDateLastYear;
          percent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
          );
          if ($ctrl.lastmtdSales.total == 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.mtdSales.percent = 100 - percent;
            $ctrl.mtdSales.trend = "down";
          } else if (percent > 100) {
            $ctrl.mtdSales.percent = percent - 100;
            $ctrl.mtdSales.trend = "up";
          } else {
            $ctrl.mtdSales.percent = 100;
            $ctrl.mtdSales.trend = "neutral";
          }
        }
      },
    });
    $ctrl.mtdSalesRanking = [];
    $ctrl.ytdSalesRanking = [];
    $ctrl.qtdSalesRanking = [];
    $ctrl.dailySalesQueryRankings = createAutoQuery({
      url:
        "QueryCustomerSalesSummary.json?Fields=strRanking&GroupBy=strRanking&Sum=TotalSalesYearToDate,TotalSalesMonthToDate,TotalSalesQuarterToDate&SalesRepID=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (obj) {
            $ctrl.mtdSalesRanking.push({
              ranking: obj.strRanking,
              sales: obj.sumTotalSalesMonthToDate,
            });
          });
          args.results.forEach(function (obj) {
            $ctrl.ytdSalesRanking.push({
              ranking: obj.strRanking,
              sales: obj.sumTotalSalesYearToDate,
            });
          });
          args.results.forEach(function (obj) {
            $ctrl.qtdSalesRanking.push({
              ranking: obj.strRanking,
              sales: obj.sumTotalSalesQuarterToDate,
            });
          });
        }
      },
    });

    $ctrl.dailyInvoiceQuery = createAutoQuery({
      url:
        "QueryInvoiceYOYTotals.json?Sum=TotalInvoiceToday,TotalInvoiceCountToday,TotalInvoiceYesterday,TotalInvoiceCountYesterday,TotalInvoiceWeekToDate,TotalInvoiceCountWeekToDate,TotalInvoiceQuarterToDate,TotalInvoiceCountQuarterToDate,TotalInvoiceQuarterToDateLastYear,TotalInvoiceCountQuarterToDateLastYear,TotalInvoiceYearToDate,TotalInvoiceCountYearToDate,TotalInvoiceYearToDateLastYear,TotalInvoiceCountYearToDateLastYear,TotalInvoiceMonthToDate,TotalInvoiceCountMonthToDate,TotalInvoiceMonthToDateLastYear,TotalInvoiceCountMonthToDateLastYear&GroupBy=SalesRepID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          var res = args.first;
          $ctrl.dailyInvoice.total = res.sumTotalInvoiceToday;
          $ctrl.dailyInvoice.count = res.sumTotalInvoiceCountToday;
          $ctrl.yesterdayInvoice.total = res.sumTotalInvoiceYesterday;
          $ctrl.yesterdayInvoice.count = res.sumTotalInvoiceCountYesterday;
          $ctrl.weekInvoice.total = res.sumTotalInvoiceWeekToDate;
          $ctrl.weekInvoice.count = res.sumTotalInvoiceCountWeekToDate;
          $ctrl.quarterInvoice.total += res.sumTotalInvoiceQuarterToDate;
          $ctrl.quarterInvoice.count += res.sumTotalInvoiceCountQuarterToDate;
          $ctrl.lastquarterInvoice.total +=
            res.sumTotalInvoiceQuarterToDateLastYear;
          $ctrl.lastquarterInvoice.count +=
            res.sumTotalInvoiceCountQuarterToDateLastYear;
          var percent = Math.round(
            ($ctrl.quarterInvoice.total / $ctrl.lastquarterInvoice.total) * 100
          );
          if ($ctrl.lastquarterInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.quarterInvoice.percent = 100 - percent;
            $ctrl.quarterInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.quarterInvoice.percent = percent - 100;
            $ctrl.quarterInvoice.trend = "up";
          } else {
            $ctrl.quarterInvoice.percent = 100;
            $ctrl.quarterInvoice.trend = "neutral";
          }
          $ctrl.ytdInvoice.total += res.sumTotalInvoiceYearToDate;
          $ctrl.ytdInvoice.count += res.sumTotalInvoiceCountYearToDate;
          $ctrl.lastytdInvoice.total += res.sumTotalInvoiceYearToDateLastYear;
          $ctrl.lastytdInvoice.count +=
            res.sumTotalInvoiceCountYearToDateLastYear;
          percent = Math.round(
            ($ctrl.ytdInvoice.total / $ctrl.lastytdInvoice.total) * 100
          );
          if ($ctrl.lastytdInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.ytdInvoice.percent = 100 - percent;
            $ctrl.ytdInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.ytdInvoice.percent = percent - 100;
            $ctrl.ytdInvoice.trend = "up";
          } else {
            $ctrl.ytdInvoice.percent = 100;
            $ctrl.ytdInvoice.trend = "neutral";
          }
          $ctrl.mtdInvoice.total += res.sumTotalInvoiceMonthToDate;
          $ctrl.mtdInvoice.count += res.sumTotalInvoiceCountMonthToDate;
          $ctrl.lastmtdInvoice.total += res.sumTotalInvoiceMonthToDateLastYear;
          $ctrl.lastmtdInvoice.count +=
            res.sumTotalInvoiceCountMonthToDateLastYear;
          percent = Math.round(
            ($ctrl.mtdInvoice.total / $ctrl.lastmtdInvoice.total) * 100
          );
          if ($ctrl.lastmtdInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.mtdInvoice.percent = 100 - percent;
            $ctrl.mtdInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.mtdInvoice.percent = percent - 100;
            $ctrl.mtdInvoice.trend = "up";
          } else {
            $ctrl.mtdInvoice.percent = 100;
            $ctrl.mtdInvoice.trend = "neutral";
          }
        }
      },
    });

    $ctrl.lastweekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&GroupBy=SalesRepID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          $ctrl.lastweekSales.total = Math.round(args.first.sumOrderTotal);
          $ctrl.lastweekSales.count = args.first.countOrderTotal;
        }
      },
    });
    $ctrl.goalsQuery = createAutoQuery({
      url:
        "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&SalesRepID=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
            $ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
            $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
          });
          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
        }
      },
    });
    $ctrl.openOrders = createAutoQuery({
      url: "QueryCarts.json?StatusNotEqualTo=Cart&salesrepid=" + $ctrl.repId,
      orderBy: "-OrderedOn",
      autoLoad: true,
      pageSize: 10,
    });

    $ctrl.backlogTotal = 0;
    $ctrl.allocatedTotal = 0;
    $ctrl.backlogSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyCustomerVendorTotals.json?Sum=Backlog,Allocated&GroupBy=vendorID&salesrepId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.backlogTotal += Math.round(res.sumBacklog);
            $ctrl.allocatedTotal += Math.round(res.sumAllocated);
          });
        }
      },
    });

		$ctrl.lastweekSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&GroupBy=SalesRepID&salesrepId=' + $ctrl.repId,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					$ctrl.lastweekSales.total = Math.round(args.first.sumOrderTotal); $ctrl.lastweekSales.count = args.first.countOrderTotal;
				}
			}
		});
		$ctrl.goalsQuery = createAutoQuery({
			url: 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&SalesRepID=' + $ctrl.repId,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
						$ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
						$ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
					});
					$ctrl.goals.monthPercent = Math.round(($ctrl.mtdSales.total / $ctrl.goals.month) * 100);
					$ctrl.goals.quarterPercent = Math.round(($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100);
					$ctrl.goals.yearPercent = Math.round(($ctrl.ytdSales.total / $ctrl.goals.year) * 100);
				}
			}
		});
		$ctrl.openOrders = createAutoQuery({
			url: 'QueryCarts.json?StatusNotEqualTo=Cart&salesrepid=' + $ctrl.repId,
			orderBy: '-OrderedOn',
			autoLoad: true,
			pageSize: 10
		});
		
		$ctrl.backlogTotal = 0;
		$ctrl.allocatedTotal = 0;
        $ctrl.pendingTotal = 0;
        $ctrl.pendingCount = 0;
		$ctrl.backlogSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerVendorTotals.json?Sum=Backlog,Allocated&GroupBy=vendorID&salesrepId=' + $ctrl.repId,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.backlogTotal += Math.round(res.sumBacklog);
						$ctrl.allocatedTotal += Math.round(res.sumAllocated);
					});
				}
			}
		});
		$ctrl.pendingOrdersQuery = createAutoQuery({
			url: 'QueryCartItemsJoin.json?Sum=ExtendedTotal&CountDistinct=CartId&ClientVersionNotEqualTo=%20&Exported=1&Status=Open&GroupBy=SalesRepId&SalesRepId=' + $ctrl.repId,
				  pageSize: 1000,
				  autoLoad: true,
				  onLoaded: function(totals) {
					  $ctrl.chartLabels = [];
					  $ctrl.chartData = [];
					  totals.results.forEach(function(total) {
						  $ctrl.pendingTotal += total.sumExtendedTotal || 0;
						  $ctrl.pendingCount += total.countDistinctCartId || 0;
					  });
				  }
			  });
	  
		$ctrl.$session = $session;
		$ctrl.markets = [];
		$ctrl.showCodesQuery = createAutoQuery({
			url: 'QueryMarketDates.json',
			autoLoad: true,
			take: 1000,
			onLoaded: function (args) {
				args.results.forEach(function (market) {
					if ($ctrl.markets.filter(m => m.market == market.market && m.year == market.year).length == 0) {
						$ctrl.markets.push(market);
					}
				});
			}
		});
		$ctrl.lastSyncDate = '';
		$ctrl.lastSyncDuration = '';
		this.lastSyncDateQuery = createAutoQuery({
			url: 'querysynchistorysummary?UserId=' + $ctrl.repId,
			pageSize: 1000,
			autoLoad: true,
			onLoaded: function (args) {
				if (args.total > 0) {
					$ctrl.lastSyncDate = args.results[0].syncStart || '';
					$ctrl.lastSyncDuration = args.results[0].syncTime || '';
				}
			}
		});
		$ctrl.quickReportsQuery = createAutoQuery({
			url: "QueryQuickReports.json?",
			orderBy: "Type,Name",
			sortOptions: {
			  "Type,Name": "Name: A to Z",
			  "-Type,Name": "Name: Z to A",
			},
			tagCriteria: {
				Dashboards: "Sales Rep"
			},
			autoLoad: true,
			onLoaded(args) {
			  $ctrl.quickReports = args.results;
			},
			pageSize: 1000,
		});
	}
	$onInit() {
		const $ctrl = this;
		/*
			setTimeout(function () {
			  window.scrollTo(0,0);
			}, 3000);
		*/
  }
  load() {
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
  performanceReport(repId) {
    let $ctrl = this;
    return modals.open({
      templateUrl: dateRangeUrl,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        $ctrl.startOn = moment().subtract(1, "days");
        $ctrl.endOn = moment().subtract(1, "days");
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          $uibModalInstance.close();
          let url = $appConfig.resolveServiceUrl(
            "RunPerformanceReport?salesrepid=" +
              repId +
              "&startDate=" +
              $ctrl.startOn.format("MM/DD/YYYY") +
              "&endDate=" +
              $ctrl.endOn.format("MM/DD/YYYY")
          );
          //					alert(url);
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&@RepId=" +
        $ctrl.repId +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }

  runReport(name) {
    const $ctrl = this;
    let url = $appConfig.resolveServiceUrl(name + "?salesrepid=" + $ctrl.repId);
    return (location.href = url);
  }

  runReportWithOptions(name, displayName) {
    let $ctrl1 = this;
    $ctrl1.bus = new ServiceBus();
    //console.log("run with options", name);
    return modals.open({
      templateUrl: dashboardQuickReportFilters,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        var monthNum = moment().month();
        $ctrl.month = moment().month(monthNum).format("MM");
        $ctrl.startOn = moment();

        $ctrl.repId = $ctrl1.repId;
        $ctrl.title = "Running for " + $ctrl1.rep.name;
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          var queryString = "";
          //$uibModalInstance.close();
          //$ctrl.startOn = $ctrl.month + "/15/" + moment().year();
          //$ctrl.startOn = $ctrl.startOn.format('MM-DD-YYYY');
          var startOn = $ctrl.startOn.format("MM-DD-YYYY");
          if ($ctrl.dateType != undefined) {
            queryString += "&dateType=" + $ctrl.dateType;
          }
          let url = $appConfig.resolveServiceUrl(
            "RunReport?reportName=" +
              name +
              "&displayName=" +
              displayName +
              "&output=xlsx&repIdOverride=" +
              $ctrl.repId +
              "&startDate=" +
              startOn +
              "&timeZoneOffset=" +
              moment().utcOffset() +
              queryString
          );
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }
  //runReportWithOptions(name) {
  //	let $ctrl1 = this;
  //	console.log("run with options" , name);
  //	return modals.open({
  //		templateUrl: dateRangeUrl,
  //		controllerAs: '$ctrl',
  //		controller($scope, $uibModalInstance, $session) {
  //			let $ctrl = this;
  //			$ctrl.startOn = moment().subtract(1, 'days');
  //			$ctrl.endOn = moment().subtract(1, 'days');
  //			$ctrl.dismiss = $ctrl.cancel = function () {
  //				$uibModalInstance.close();
  //			}
  //			$ctrl.runReport = function () {
  //				$uibModalInstance.close();
  //				let url =
  //					$appConfig.serviceUrl + name
  //					"?salesrepid=" + $ctrl1.repId + "&startDate=" + $ctrl.startOn.format("MM/DD/YYYY") + "&endDate=" + $ctrl.endOn.format("MM/DD/YYYY");
  //				//					alert(url);
  //				return location.href = url;
  //			}
  //		},
  //		size: 'lg'
  //	}).result
  //}
}

let SalesRepDashboard = {
  bindings: {
    repId: "@",
    repGroup: "@",
    repGroupId: "@",
  },
  require: {
    container: "^salesrepContainer",
  },
  controller: SalesRepDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default SalesRepDashboard;
